import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import Progress from "react-progressbar";
import { defaultLogo, UNO_URL } from "../../../env";
import { CloseIcon } from "../../../assets/Icons";
import { useNavigate } from "react-router-dom";
import * as Papa from "papaparse";
import apiClient from "../../../apiClient";
import { useSelector } from "react-redux";
import { RESOURCE_QUIZ, SAVE_ASSESSMENT } from "../../../apiClient/apiEndpoints";
import { convertFileSize } from "../../../utils/constant";
import moment from "moment";

const fileTypes = ["csv"];
const CSV_HEADERS = ["QuestionType", "Question", "OptionA"];
const validateCsv = (headersData) => CSV_HEADERS.reduce((init, item) => init && headersData.includes(item), true);

const Assessment = ({ moduleData }) => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.configSlice);
  const UNO_URL = configData?.config?.UNO_URL;
  const [findQuiz,setFindQuiz] = useState(null);
  const [file, setFile] = useState({
    hindi: null,
    english: null,
  });
  const [progress, setProgress] = useState({
    english: 0,
    hindi: 0,
  });
  const [fileJson, setFileJson] = useState({
    hindi: null,
    english: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    english: false,
    hindi: false,
  });
  const isSaveDisabled = !(file.english && file.hindi);

  const handleGetResourceQuiz =async()=>{
     try {
      let data = await apiClient.get(`${UNO_URL}${RESOURCE_QUIZ}/${moduleData.uuid}`);
      let quiz = data?.children[0]?.versions[0] || null;
      setFindQuiz(quiz);
     } catch (error) {
      console.log(error);
     }
  };

  useEffect(()=>{
    if(moduleData.uuid){
      handleGetResourceQuiz();
    }
  },[moduleData])

  const handleFileChange = (file, language) => {
    setFile((prev) => ({ ...prev, [language]: file }));
    Papa.parse(file, {
      complete: (results) => {
        const headers = results.meta.fields;
        if (validateCsv(headers)) {
          setError((prev) => ({ ...prev, [language]: false }));
          setProgress((prev) => ({ ...prev, [language]: 100 }));
        } else {
          setError((prev) => ({ ...prev, [language]: true }));
        }
        setFileJson((prev) => ({ ...prev, [language]: results.data }));
      },
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
    });
  };

  const handleRemoveFile = (language) => {
    setFile((prev) => ({ ...prev, [language]: null }));
    setFileJson((prev) => ({ ...prev, [language]: null }));
    setProgress((prev) => ({ ...prev, [language]: 0 }));
  };

  const handleSave = async () => {
    if (error.english || error.hindi) return;
    setLoading(true);
    const body = Object.keys(fileJson || {})?.map((key) => ({ language: key, data: fileJson[key] }));
    await apiClient.post(`${UNO_URL}${SAVE_ASSESSMENT}/${moduleData.uuid}`, body);
    setLoading(false);
    handleGetResourceQuiz();
    alert("Success !");
  };

  return (
    <div className="assesment mt-4">
      <div className="module-view">
        <img className="p-2" src={moduleData?.versions?.[0]?.data?.thumbnail || defaultLogo} alt="Default Logo" />
        <div className="information">
          <p className="name">{moduleData?.name}</p>
          <p className="name">ID - {moduleData?.uuid}</p>
          <p className="des">{moduleData?.versions?.[0]?.data?.short || ""}</p>
        </div>
      </div>
      <div className="upload-files mt-5">
        <h6>Upload Assessment File</h6>
        {findQuiz?.data?.quiz.length > 0 && <p>Last update quiz: {moment(findQuiz?.updatedAt).format("LLL")}</p>}
        <div className="row">
          {/* Hindi File Uploader */}
          <div className="col-md-5 asses-upload">
            <p>Hindi Assessment*</p>
            <div className="fileuploader">
              {!file.hindi ? (
                <FileUploader
                  handleChange={(file) => handleFileChange(file, "hindi")}
                  name="hindiFile"
                  types={fileTypes}
                  label="Drag & drop or choose an CSV file to upload"
                />
              ) : (
                <div className="uploaded-file">
                  <div className="uploaddata">
                    <div className="xr">
                      <p>{file.hindi?.name}</p>
                      <p style={{ cursor: "pointer", lineHeight: "1rem" }} onClick={() => handleRemoveFile("hindi")}>
                        <CloseIcon />
                      </p>
                    </div>
                    <div className="xr">
                      <p className="filesize">{convertFileSize(file.hindi?.size || 0)}</p>
                      <p className="filesize percentage">{progress.hindi}%</p>
                    </div>
                    <Progress completed={progress.hindi} />
                    {error.hindi && <p>Incorrect Format</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* English File Uploader */}
          <div className="col-md-5 asses-upload">
            <p>English Assessment*</p>
            <div className="fileuploader">
              {!file.english ? (
                <FileUploader
                  handleChange={(file) => handleFileChange(file, "english")}
                  name="englishFile"
                  types={fileTypes}
                  label="Drag & drop or choose an CSV file to upload"
                />
              ) : (
                <div className="uploaded-file">
                  <div className="uploaddata">
                    <div className="xr">
                      <p>{file.english?.name}</p>
                      <p style={{ cursor: "pointer", lineHeight: "1rem" }} onClick={() => handleRemoveFile("english")}>
                        <CloseIcon />
                      </p>
                    </div>
                    <div className="xr">
                      <p className="filesize">{convertFileSize(file?.english?.size || 0)}</p>
                      <p className="filesize percentage">{progress.english}%</p>
                    </div>
                    <Progress completed={progress.english} />
                    {error.english && <p>Incorrect Format</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="footerbtn mt-5 pt-4">
        <button onClick={() => navigate("/dashboard/xr")}>Cancel</button>
        <button disabled={isSaveDisabled || loading} onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default Assessment;
